var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.4785,
    r: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_9777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.726 26.1424H14.2025V18.0275H16.726V26.1424ZM15.4643 16.9219C14.6541 16.9219 14 16.2678 14 15.4609C14 14.6541 14.6541 14 15.4643 14C16.2711 14 16.9252 14.6541 16.9252 15.4609C16.9252 16.2645 16.2711 16.9219 15.4643 16.9219ZM26.1689 26.1424H23.6488V22.1979C23.6488 21.2582 23.6322 20.0463 22.3373 20.0463C21.0258 20.0463 20.8266 21.0723 20.8266 22.1314V26.1424H18.3098V18.0275H20.727V19.1365H20.7602C21.0955 18.499 21.9189 17.825 23.1441 17.825C25.6975 17.825 26.1689 19.5051 26.1689 21.6898V26.1424Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_9777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.47852)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.edd3f0aadc7c1d6ed7a30cecb3c7bb2f.svg";
export { ForwardRef as ReactComponent };